module.exports = __webpack_public_path__ + "static/media/optima-seguros-provider.b93822ee.svg";